import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import {
  SET_MEMBER,
  OPEN_RECENT_SEARCH_FLYOUT,
  SET_RECENT_SEARCH,
  LOAD_RECENT_SEARCHES,
  CLEAR_RECENT_SEARCHES,
  TOGGLE_OON_WIDGET,
  SET_SELECTED_PROVIDER_PLN,
  SET_CLAIMS_CRITERIA,
  SET_ELIGIBILITY_CRITERIA,
  SET_REFERRAL_CRITERIA,
  OPEN_TRACKIT_FLYOUT,
  SEARCH_CURRENT_MEMBER,
  DOCLIB_ADV_SEARCH_FLYOUT,
  PROVIDER_PREFERENCE_ERROR,
  SET_VIEWED_PROVIDER_CHAT_MODAL,
  PROVIDER_PREFERENCE_COMPLETE,
} from './constants';

const initialState = {
  isOONWidgetOpen: false,
  oonWidgetData: {},
  member: {
    memberId: '',
    memberDateOfBirth: '',
  },
  recentSearchFlyout: {
    isOpen: false,
    searches: [],
  },
  searchCriteria: {
    claims: {
      isModified: false,
    },
    eligibility: {
      isModified: false,
    },
  },
  trackItFlyout: {
    isOpen: false,
    appName: 'claims',
  },
  searchCurrentMember: false,
  docLibSearchFlyout: {
    isOpen: false,
  },
  providerPreferenceError: {},
  viewedProviderChatModal: false,
  providerPreferenceComplete: false,
};

export const dashboardReducer = createReducer(initialState, {
  [SET_MEMBER]: (state, action) => {
    return {
      member: action.payload,
    };
  },

  [SET_SELECTED_PROVIDER_PLN]: (state, action) => {
    return {
      oonWidgetData: action.payload,
    };
  },

  [TOGGLE_OON_WIDGET]: (state, action) => {
    return {
      isOONWidgetOpen: action.payload,
    };
  },

  [OPEN_RECENT_SEARCH_FLYOUT]: (state, action) => {
    return {
      recentSearchFlyout: {
        ...state.recentSearchFlyout,
        isOpen: action.payload,
      },
    };
  },

  [SET_RECENT_SEARCH]: (state, action) => {
    return {
      recentSearchFlyout: {
        ...state.recentSearchFlyout,
        searches: action.payload,
      },
    };
  },

  [LOAD_RECENT_SEARCHES]: (state, action) => {
    return {
      recentSearchFlyout: {
        ...state.recentSearchFlyout,
        searches: action.payload || [],
      },
    };
  },

  [CLEAR_RECENT_SEARCHES]: () => {
    return {
      recentSearchFlyout: {
        searches: [],
        isOpen: true,
      },
    };
  },

  [SET_CLAIMS_CRITERIA]: (state, action) => {
    return {
      searchCriteria: {
        ...state.searchCriteria,
        claims: action.payload,
      },
    };
  },

  [SET_ELIGIBILITY_CRITERIA]: (state, action) => {
    return {
      searchCriteria: {
        ...state.searchCriteria,
        eligibility: action.payload,
      },
    };
  },

  [SET_REFERRAL_CRITERIA]: (state, action) => {
    return {
      searchCriteria: {
        ...state.searchCriteria,
        referral: action.payload,
      },
    };
  },

  [OPEN_TRACKIT_FLYOUT]: (state, action) => {
    return {
      trackItFlyout: {
        ...action.payload,
      },
    };
  },

  [SEARCH_CURRENT_MEMBER]: (state, action) => {
    return {
      searchCurrentMember: action.payload,
    };
  },

  [DOCLIB_ADV_SEARCH_FLYOUT]: (state, action) => {
    return {
      docLibSearchFlyout: {
        ...action.payload,
      },
    };
  },
  [PROVIDER_PREFERENCE_ERROR]: (state, action) => {
    return {
      providerPreferenceError: {
        ...action.payload,
      },
    };
  },
  [SET_VIEWED_PROVIDER_CHAT_MODAL]: (state, action) => {
    return {
      viewedProviderChatModal: action.payload,
    };
  },
  [PROVIDER_PREFERENCE_COMPLETE]: (state, action) => {
    return {
      providerPreferenceComplete: action.payload,
    };
  },
});
